export const LOAD_STORYLINE   = 'LOAD_STORYLINE'
export const LOAD_STORYLINE_FAIL   = 'LOAD_STORYLINE_FAIL'


export const LOAD_DICTIONARY   = 'LOAD_DICTIONARY'
export const LOAD_DICTIONARY_FAIL   = 'LOAD_DICTIONARY_FAIL'


